import { render, staticRenderFns } from "./HsabExpenseForm.vue?vue&type=template&id=56b8197b&scoped=true"
import script from "./HsabExpenseForm.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseForm.vue?vue&type=script&lang=ts"
import style0 from "./HsabExpenseForm.vue?vue&type=style&index=0&id=56b8197b&prod&lang=scss"
import style1 from "./HsabExpenseForm.vue?vue&type=style&index=1&id=56b8197b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b8197b",
  null
  
)

export default component.exports